module.exports = __webpack_public_path__ + "static/media/pic-laufrouten-4.b3163576.jpg";